import { Collapse, Stack } from "@mui/material";
import { useState } from "react";
import { AllPastTimesMessage } from "./AllPastTimesMessage";
import { EmptyTimesMessage } from "./EmptyTimesMessage";
import { ExpiredTimesList } from "./ExpiredTimesList";
import { ExpiredTimesToggle } from "./ExpiredTimesToggle";
import { TimesTable } from "./TimesTable";
import { DateWiseSlotPickerProps } from "./types";
import { getSortedDateKeys } from "./utils";

export type { DateWiseSlotPickerProps, SlotsByDate } from "./types";

export function DateWiseSlotPicker({
  slotsByDate,
  pastSlotsByDate = {},
  selectedSlot,
  isTimeConfirmed,
  onSlotSelect,
  onSwitchToSuggestTime,
  emptyMessage = "No times available",
  emptySubmessage = "There are no available times. You can suggest alternative times below.",
}: DateWiseSlotPickerProps) {
  const [showExpiredTimes, setShowExpiredTimes] = useState(false);
  const hasFutureTimes = Object.keys(slotsByDate).length > 0;
  const hasExpiredTimes = Object.keys(pastSlotsByDate).length > 0;

  if (!hasFutureTimes && !hasExpiredTimes) {
    return <EmptyTimesMessage message={emptyMessage} submessage={emptySubmessage} />;
  }

  const toggleExpiredTimes = () => setShowExpiredTimes((prev) => !prev);

  return (
    <Stack gap={1.5}>
      {!hasFutureTimes && hasExpiredTimes ? (
        <AllPastTimesMessage onSwitchToSuggestTime={onSwitchToSuggestTime} />
      ) : (
        <TimesTable
          dateKeys={getSortedDateKeys(slotsByDate)}
          slotsByDate={slotsByDate}
          selectedSlot={selectedSlot}
          isTimeConfirmed={isTimeConfirmed}
          onSlotSelect={onSlotSelect}
        />
      )}
      {hasExpiredTimes && (
        <>
          <ExpiredTimesToggle
            showExpiredTimes={showExpiredTimes}
            onToggle={toggleExpiredTimes}
          />
          <Collapse in={showExpiredTimes}>
            <ExpiredTimesList pastSlotsByDate={pastSlotsByDate} />
          </Collapse>
        </>
      )}
    </Stack>
  );
}
